<template>
  <div class="reports">
    <div v-if="$store.state.pageLoaded" class="reports-listing">
      <div class="filter-wrapper">
        <md-datepicker v-model="period.from" md-immediately>
          <label>Od</label>
        </md-datepicker>
        <md-datepicker v-model="period.to" md-immediately>
          <label>Do</label>
        </md-datepicker>
        <md-button class="md-raised md-dense md-primary" v-on:click="getByDate">
          Traži
        </md-button>
      </div>
      <div ref="reports">
      <h2 class="md-title">
        Gotovinsko izvješće u periodu
        <span>{{ title }}</span>
        <span v-if="$store.state.receivedData.reportsCash.list.tickets.length">
          <br>
          <b>Ukupno: {{ formatCurrency($store.state.receivedData.reportsCash.list.sum) }}</b>
        </span>
      </h2>
      <div v-if="$store.state.receivedData.reportsCash.list.tickets.length != 0">
        <div class="single-table">
          <md-table class="reports-table print-table reports-cash" md-sort="transaction_time" v-model="$store.state.receivedData.reportsCash.list.tickets">
            <md-table-row md-selectable="single" md-auto-select slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Predstava" md-sort-by="play_title">{{ item.play_title }}</md-table-cell>
              <md-table-cell md-label="Datum i vrijeme" md-sort-by="play_time">{{ new Date(item.play_time).toLocaleString('hr-HR') }}</md-table-cell>
              <md-table-cell md-label="Vrijeme transakcije" md-sort-by="transaction_time">{{ new Date(item.transaction_time).toLocaleString('hr-HR') }}</md-table-cell>
              <md-table-cell md-label="Sjedalo" md-sort-by="position">
                {{ item.position }} {{ item.side }}<br>
                Red: {{ item.row }}<br>
                Sjedalo: {{ item.seat }}
              </md-table-cell>
              <md-table-cell md-label="Status" md-sort-by="status">{{ getStatus(item.status) }}</md-table-cell>
              <md-table-cell md-label="Blagajnik" md-sort-by="user">
                <b>{{ item.user }}</b>
              </md-table-cell>
              <md-table-cell md-label="Cijena" md-sort-by="price">
                {{ formatCurrency(item.price) }}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
        <md-button class="md-primary md-dense md-raised print-btn fixed-print-btn" v-on:click="print($refs.reports)">
          Ispiši
        </md-button>
      </div>
      <div v-else class="error">
        <h3>Nažalost nema izvješća za prikaz</h3>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ReportsMixin from '../../../mixins/reports-mixin';
import FormatCurrency from '../../../mixins/format-currency';

export default {
  name: 'ReportsIncome',
  mixins: [FormatCurrency, ReportsMixin('getReportsCash')],
  computed:{
    ...mapGetters([
      'getStatus'
    ])
  },
  mounted(){
    let today = new Date().toLocaleDateString('hr-HR');
    this.title = `od ${today}
    do ${today}`
  }
}
</script>

<style lang="scss" scoped>
  .filter-wrapper{
    display: flex;
    position: relative;
    max-width: 900px;

    .md-field{
      margin-right: 20px;
    }
  }

  .reports h2{
    text-align: center;
    margin: 50px 0;
    span{
      display: block;
    }

    .lighter{
      margin-top: 15px;
      font-size: 16px;
    }
  }

  .reports-cash td{
    vertical-align: top;
  }

  .error{
    font-size: 22px;
    margin: 50px 0;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/ReportsCash.vue